<template>
  <div>
  <div
    class="row-login"
    :style="{
      backgroundImage: 'url(' + require('@/assets/images/log/bg.jpg') + ')',
    }"
  >
    <div class="header-log">
      <div class="wp">
        <div class="logo-log">
          <img v-if="commonConfig.bk_config_login_logo" :src="commonConfig.bk_config_login_logo"/>
          <img v-else src="@/assets/images/log/logo.png" alt="">
        </div>
      </div>
    </div>
    <div class="m-logbox1">
      <div class="top">
        <div class="tit">布克云图书查单服务平台</div>
        <div class="desc">Bookcloud Book Query Service Platform</div>
      </div>
      <div class="m-sw">
        <div class="btn-qr" @click="showClick">
          <img src="@/assets/images/log1.png" class="img img1" v-if="!isShow" alt="" />
          <img src="@/assets/images/log1-1.png" class="img img2"  v-if="isShow" alt="" />
        </div>
        <div class="box1">
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="txt">会员登录</div>
            </div>
            <!-- <div class="swiper-slide">
              <div class="txt">供应商登录</div>
            </div>
            <div class="swiper-slide">
              <div class="txt">选书登录</div>
            </div> -->
          </div>
          <!-- 如果需要导航按钮 -->
<!--          <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--          <div class="swiper-button-next" slot="button-next"></div>-->
        </div>
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div class="swiper-slide swiper-no-swiping">
              <div class="m-formg1">
                <form action="" onsubmit="return false">
                  <div class="form">
                    <div class="li">
                      <div class="con con-num">
                        <div class="left">
                          <el-select v-model="value" placeholder="请选择">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入手机号"
                            v-model="username"
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con">
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入密码"
                            v-model="password"
                            show-password
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con con-code">
                        <div class="inpbox">
                          <el-input
                              alt="captcha"
                            placeholder="请输入验证码"
                            v-model="vercode"
                            class="inp"
                          ></el-input>
                        </div>
                        <div class="codeimg" @click="getCaptcha">
                          <img :src="captchaImg" alt="验证码" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="g-btns1" v-loading="loading" @click="login">登 录</button>
                  <div class="m-ckbox">
                    <div class="left">
                      <el-checkbox-group v-model="type">
                        <el-checkbox
                          label="下次自动登录"
                          name="auto"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="links">
                      <router-link to="/password" class="a">忘记密码</router-link>
                      |
                      <router-link to="/signin?type=0" class="a">注册</router-link>
                    </div>
                  </div>
                  <!-- <button type="button" class="g-btns1 btn-wechat" @click="loginByWechat">
                    <img class="wechat" src="@/assets/images/wechat_mini.png"/>使用微信扫码登录
                  </button>-->
                  <div class="tips">登录或注册即代表同意
                    <a href="/home/index/protocol/type/bk_user_protocol.html" target="_blank" class="a">《用户协议》</a> 和
                    <a href="/home/index/protocol/type/bk_privacy_protocol.html" target="_blank" class="a">《隐私政策》</a>
<!--                    <a href="javascript:;" class="a" @click="protocol.type='bk_user_protocol';protocol.show=true">《用户协议》</a> 和-->
<!--                    <a href="javascript:;" class="a" @click="protocol.type='bk_privacy_protocol';protocol.show=true">《隐私政策》</a>-->
                  </div>
                </form>
              </div>
            </div>
            <!-- <div class="swiper-slide swiper-no-swiping">
              <div class="m-formg1">
                <form action="" onsubmit="return false">
                  <div class="form">
                    <div class="li">
                      <div class="con con-num">
                        <div class="left">
                          <el-select v-model="value" placeholder="请选择">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入手机号"
                            v-model="username"
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con">
                        <div class="inpbox">
                          <el-input
                              alt="captcha"
                            placeholder="请输入密码"
                            v-model="password"
                            show-password
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con con-code">
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入验证码"
                            v-model="vercode"
                            class="inp"
                          ></el-input>
                        </div>
                        <div class="codeimg">
                          <img :src="captchaImg" alt="验证码" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="g-btns1" v-loading="loading" @click="login">登 录</button>
                  <div class="m-ckbox">
                    <div class="left">
                      <el-checkbox-group v-model="type">
                        <el-checkbox
                          label="下次自动登录"
                          name="auto"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="links">
                      <router-link to="/password" class="a">忘记密码</router-link>
                      |
                      <router-link to="/signin?type=1" class="a">注册</router-link>
                    </div>
                  </div>
                  <div class="tips">登录或注册即代表同意
                    <a href="/home/index/protocol/type/bk_user_protocol.html" target="_blank" class="a">《用户协议》</a> 和
                    <a href="/home/index/protocol/type/bk_privacy_protocol.html" target="_blank" class="a">《隐私政策》</a>
                  </div>
                </form>
              </div>
            </div>
            <div class="swiper-slide swiper-no-swiping">
              <div class="m-formg1">
                <form action="" onsubmit="return false">
                  <div class="form">
                    <div class="li">
                      <div class="con con-num">
                        <div class="left">
                          <el-select v-model="value" placeholder="请选择">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入手机号"
                            v-model="username"
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con">
                        <div class="inpbox">
                          <el-input
                            placeholder="请输入密码"
                            v-model="password"
                            show-password
                            class="inp"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="con con-code">
                        <div class="inpbox">
                          <el-input
                              alt="captcha"
                            placeholder="请输入验证码"
                            v-model="vercode"
                            class="inp"
                          ></el-input>
                        </div>
                        <div class="codeimg">
                          <img :src="captchaImg" alt="验证码" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="g-btns1" v-loading="loading" @click="login">登 录</button>
                  <div class="m-ckbox">
                    <div class="left">
                      <el-checkbox-group v-model="type">
                        <el-checkbox
                          label="下次自动登录"
                          name="auto"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="links">
                      <router-link to="/password" class="a">忘记密码</router-link>
                      |
                      <router-link to="/signin?type=2" class="a">注册</router-link>
                    </div>
                  </div>
                  <div class="tips">登录或注册即代表同意
                    <a href="/home/index/protocol/type/bk_user_protocol.html" target="_blank" class="a">《用户协议》</a> 和
                    <a href="/home/index/protocol/type/bk_privacy_protocol.html" target="_blank" class="a">《隐私政策》</a>
                  </div>
                </form>
              </div>
            </div> -->
          </div>
        </div>
      </div>
        <div class="box2" v-if="isShow">
          <div class="m-formg1">
            <div class="m-boqr">
              <div class="qr-top">
                <img src="@/assets/images/log2.png" class="icon" alt="" />
                <span class="span1">微信扫码</span>登录
              </div>
<!--              <img src="@/assets/images/pic1-1.jpg" class="img" alt="" />-->
              <div v-show="isWxQrcodeReady" class="img" id="wechatQrCode" style="width: 200px;height: 200px;"></div>
            <div class="tips">
              登录或注册即代表同意
              <router-link to="/" class="a">用户协议</router-link> 和
              <router-link to="/" class="a">隐私政策</router-link>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-logdw">Copyright ©
        <router-link to="/" class="a">{{ commonConfig.bk_config_copyright }}</router-link>
        <a href="https://beian.miit.gov.cn/" class="a" target="_blank">
        {{ commonConfig.bk_config_beian }}</a>  </div>
    </div>
  </div>
    <protocol-dialog :show.sync="protocol.show" :type="protocol.type"></protocol-dialog>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
import {get} from "@/utils/request";
import {getApiRes} from "@/api/apiUtil";
import {login} from "@/api/user";
import ProtocolDialog from "@/components/ProtocolDialog.vue";
export default {
  components: {ProtocolDialog},
  data() {
    return {
      isShow: false,
      isWxQrcodeReady: false,
      captchaImg: '',
      captchaRandom: 0,
      loading: false,
      options: [
        {
          value: "0",
          label: "+86",
        },
        // {
        //   value: "1",
        //   label: "+87",
        // },
      ],
      value: "+86",
      input1: "",
      username: "",
      password: "",
      vercode: "",
      select: "",
      type: [],
      redirect: undefined,
      otherQuery: {},
      protocol: {
        show:false,
        type: ''
      }
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  computed: {
    isDevMode(){
      return process.env.NODE_ENV === 'development'
    }
  },

  mounted() {
    // this.showQrCode()
    this.galleryThumbsLunbo();
    this.galleryTopLunbo();
    this.getCaptcha()
    // 进入登录页就调用退出登录接口，确保和php渲染页面登录状态一致
    this.$store.dispatch('user/logout')
  },

  methods: {
    showClick() {
        this.isShow = !this.isShow
      if(this.isShow){
        this.showQrCode() //刷新二维码
      }
    },
    showQrCode(){
      let that = this
      this.$nextTick(()=>{
        var obj = new WxLogin({
          self_redirect:false,
          id:"wechatQrCode",
          appid: "wx6e4b7c4af522e0a5",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(`${window.location.protocol}//${window.location.host}/user/login/wxwebLoginCallback`),
          // state: "",
          // style: "",
          stylelite: 0, //自定义样式
          href: encodeURIComponent(`${window.location.protocol}//${window.location.host}/dist/css/wechatLogin.css`),
          onQRcodeReady: function(){
            setTimeout(()=>{
              that.isWxQrcodeReady = true
            }, 500)
          }
        });
      })
    },
    async login(){
      // 检查
      if(!this.username) return this.$message.error('请输入手机号')
      if(!this.password) return this.$message.error('请输入密码')
      if(!this.vercode) return this.$message.error('请输入验证码')
      // 登录
      this.loading = true
      this.$store.dispatch('user/login',{username: this.username, password:this.password, vercode: this.vercode, captchaRandom: this.captchaRandom})
        .then((data)=>{
          this.$message.success('登录成功')
          // 根据角色进入首页
          console.log('login user', data)
          let defaultPath = '/home-supplier'
          // 供应商登录后跳转主页
          if(data && (data.userInfo.type==0||data.userInfo.type==2)){
            if(data.userInfo.type==2){ // 选书会员进项目管理
              defaultPath = '/membercenter-projectmanagement'
              if(this.isDevMode) defaultPath = '/info-center'
            }else { // 普通会员进首页
              defaultPath = '/'
              // 开发模式跳转
              if(this.isDevMode) defaultPath = '/home-center'
            }
          }else{
            if(this.isDevMode) defaultPath = '/home-supplier'
            else {
              window.location.href = '/home/user_info/home?id=' + data.userInfo.showId
              return
            }
          }
          this.$router.push({ path: defaultPath, query: this.otherQuery }) //this.redirect ||
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.getCaptcha()
        })
      // let re = await getApiRes(login({username: this.username, password:this.password, vercode: this.vercode, captchaRandom: this.captchaRandom}))
      // if(re.code === 0){
      //   this.$message.success('登录成功')
      //   localStorage.setItem('token', re.data.token)
      //   this.$router.push('/')
      // }
    },
    loginByWechat(){
      // window.open('/user/login/wxwebLogin')
      window.location.href = '/user/login/wxwebLogin'
      // console.log('1')
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    arrayBufferToBase64Img: (buffer) => {
      const str = String.fromCharCode(...new Uint8Array(buffer));
      return `data:image/png;base64,${window.btoa(str)}`;
    },
    ArrayBufferToBase64(buffer) {
      //第一步，将ArrayBuffer转为二进制字符串
      var binary = '';
      var bytes = new Uint8Array(buffer);
      console.log('bytes',bytes)
      for (var len = bytes.byteLength, i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      //将二进制字符串转为base64字符串
      return window.btoa(binary);
    },
    getCaptcha(){
      this.captchaRandom = Math.random()
      this.captchaImg = `/user/login/verify?id=${this.captchaRandom}`
      return
      // 小程序中是不支持blob格式数据的，new Blob()会报错Blob未定义
      // 处理方法是转成base64格式：
      // return BaseUrl + 'user/login/verify?id='+Math.random()+'.png'
      // get('/user/login/verify?id='+Math.random()+'.png', {}).then(re=>{
      //   console.log(new Blob(re))
      //   // const arrBuf = new Uint8Array(re)
      //   // const base64 = 'data:image/png;base64,' + arrayBufferToBase64(arrBuf)
      //   this.captchaImg = this.ArrayBufferToBase64(re)
      // })
    },
    galleryThumbsLunbo() {
      this.galleryThumbs = new Swiper(".gallery-thumbs1", {
        spaceBetween: 15, //在slide之间设置距离（单位px）
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量
        // loop: true,        //设置为true 则开启loop模式
        freeMode: true, //默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 2, //一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true, //开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true, //开启这个参数来计算每个slide的progress(进度、进程)
      });
    },
    galleryTopLunbo() {
      this.galleryTop = new Swiper(".gallery-top1", {
        noSwiping: true,
        spaceBetween: 10,
        // loop: true,
        loopedSlides: 2,
        // 左右按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          //thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs,
        },
      });
    },
  },

  created() {
    // setTimeout(()=>{
    //   this.galleryThumbsLunbo();
    //   this.galleryTopLunbo();
    // },500)
  },
};
</script>

<style lang="scss" scoped></style>
